import { Component, OnInit, Injector } from '@angular/core';
import { ReportsService, Statuses } from '../reports.service';

@Component({
  selector: 'ga-wo-hold-report-form',
  templateUrl: './ga-wo-hold-report-form.component.html',
  styleUrls: ['../../../dialogs/ga-wo-submit-report-dialog/ga-wo-submit-report-dialog.component.scss',
    '../../../../work-orders.component.scss']
})
export class GaWoHoldReportFormComponent implements OnInit {
  service: ReportsService;

  constructor(injector: Injector) {
    this.service = injector.get(ReportsService);
    this.service.status = Statuses.OnHold;
  }

  ngOnInit() {
    this.service.editForm.get('ActualStartDate').setValue(new Date());
    Promise.all([
      this.service.getStatuses(Statuses.OnHold),
      this.service.getDefaultContacts(),
      this.service.populateContactsList()
    ]);
  }
}
